"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * These phone numbers are used in all components
 * Change them here and all components will get them.
 */
exports.PHONE_NUMBER = '1300003726';
exports.PHONE_NUMBER_FORMATTED = '1300 003 726';
